var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBymInfoMarkCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    fill: "currentColor",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.996 31C7.766 30.998.998 24.225 1 15.996 1.002 7.766 7.775.998 16.004 1c8.23.002 14.998 6.775 14.996 15.004-.002 8.23-6.775 14.998-15.004 14.996zm0-2c7.132.002 13.002-5.864 13.004-12.996C29.002 8.872 23.136 3.002 16.004 3 8.872 2.998 3.002 8.864 3 15.996 2.998 23.128 8.864 28.998 15.996 29zm.005-18c-1.097 0-2-.904-1.999-2 0-1.098.904-2 2-2 1.098 0 2 .904 2 2 0 1.098-.904 2-2 2zm-1.504 14l.003-12h3l-.003 12h-3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBymInfoMarkCircle);
export default __webpack_public_path__ + "static/media/BYM_info-mark-circle.a4aebd71.svg";
export { ForwardRef as ReactComponent };